export const COOKIES_NAME = 'clpHeaderFirstName';
